"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var CancelButton =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CancelButton, _PureComponent);

  function CancelButton() {
    (0, _classCallCheck2.default)(this, CancelButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CancelButton).apply(this, arguments));
  }

  (0, _createClass2.default)(CancelButton, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        size: "extra-small",
        onClick: this.props.onClick
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "cancel"
      }));
    }
  }]);
  return CancelButton;
}(_react.PureComponent);

exports.default = CancelButton;
module.exports = exports.default;